import httpClient from '@/libs/http-client'
import { encrypt } from '@/libs/utils'

export function signIn (params) {
  const url = '/user/login'
  params.password = encrypt(params.password, params.username)

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function signUp (params) {
  const url = '/user/signup'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function refreshToken (token) {
  const url = '/auth/refresh'
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  return httpClient.post(url, {}, config).then(response => {
    return response.data.result
  })
}

export function getUserInfo () {
  const url = '/user/get_info'

  return httpClient.post(url).then(response => {
    return response.data.result
  })
}

export function findPassword (params) {
  const url = '/user/find_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function resetPassword (params) {
  const url = '/user/reset_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupId (params) {
  const url = '/user/check_dup_id'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function modify (params, userId = null) {
  const url = '/user/modify'

  if (userId) {
    if (params.userPw) {
      params.userPw = encrypt(params.userPw, userId)
    }
    if (params.userPw) {
      params.userNewPw = encrypt(params.userNewPw, userId)
    }
  }

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getPvStatus (startDate, endDate) {
  const url = '/user/get_pv_status'

  return httpClient.post(url, { startDate, endDate }).then(response => {
    return response.data.result
  })
}

export function deactivateInfo () {
  const url = '/user/deactivate_info'

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function deactivate (params) {
  const url = '/user/deactivate'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function myInfoLogin (username, password) {
  const url = '/user/myinfo_login'
  password = encrypt(password, username)

  return httpClient.post(url, { password }).then(response => {
    return response.data.result
  })
}

export function planHistory (startDate, endDate) {
  const url = '/plan_history/list'

  return httpClient.post(url, { startDate, endDate }).then(response => {
    return response.data.result
  })
}

export function insertLoginHistory (params) {
  const url = '/new_user/insert_login_history'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkReferral (params) {
  const url = '/new_user/check_referral'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}
